'use client'
import { FC, useEffect, useState } from 'react'

import Image from 'next/image'

const Footer: FC = () => {
  const [partner, setPartner] = useState<Record<string, string>>()

  useEffect(() => {
    localStorage.removeItem('partner')
    const loadPartner = () => {
      const storedPartner = localStorage.getItem('partner')
      if (storedPartner) {
        setPartner(JSON.parse(storedPartner))
      }
    }

    window.addEventListener('partnerUpdated', loadPartner)
    loadPartner() // Carrega inicialmente

    return () => {
      window.removeEventListener('partnerUpdated', loadPartner)
    }
  }, [])

  return (
    <>
      <footer className="px:lg-0 relative mt-auto bg-teal-900 bg-cover px-8 py-24">
        <div className="container mx-auto text-center">
          <div className="flex items-center justify-center text-white">
            <div className="mb-6 flex flex-col items-center sm:flex-row sm:gap-10">
              <Image
                className="mx-auto mb-8 lg:mb-14"
                src="/img/Logo-BC-Energia-Vertical-Branco.svg"
                alt="BC Energia"
                width={257}
                height={148}
              />
              {partner && partner.Link_Logo_Parceiro_Rodape__c && (
                <div className="pb-8">
                  <Image
                    className="h-auto w-[35rem]"
                    src={partner.Link_Logo_Parceiro_Rodape__c}
                    alt={partner.Name as string}
                    width={400}
                    height={400}
                    priority
                  />
                </div>
              )}
            </div>
          </div>
          <div className="grid items-center gap-6 text-white lg:grid-cols-2 lg:gap-8">
            <div>
              <h2 className="mb-2 text-lg">Endereço em Goiânia:</h2>
              <p>
                Av. Dep. Jamel Cecílio, c/ rua 56, nº 2929, Salas 2802/2803 - Ed. Brookfield Towers
                Torre B - Jardim Goiás, Goiânia - GO, 74810-240
              </p>
            </div>
            <div className="md:flex-1">
              <h2 className="mb-2 text-lg">Endereço em São Paulo:</h2>
              <p>
                Av. Pres. Juscelino Kubitschek, 360 - 7º andar cj71 - Edifício JK 360 -Vila Nova
                Conceição, São Paulo - SP, 04543-000
              </p>
            </div>
          </div>
        </div>
      </footer>
      <div className="bg-teal-600 pb-5 pt-6 text-white">
        <div className="container mx-auto text-center">
          <strong>© GRUPO BC ENERGIA - 2024</strong> | TODOS OS DIREITOS RESERVADOS
        </div>
      </div>
    </>
  )
}

export default Footer
